import React, { useContext, useEffect } from 'react'
import Context from '../../context'

function OffersSelector() {
  const { user, whiteLabels, formObject, setFormObject } = useContext(Context)

  const whiteLabelsKey = {
    '/scriptform': 'scriptsWhiteLabels',
    '/momentform': 'momentsWhiteLabels',
    '/eventform': 'eventsWhiteLabels'
  }[window.location.pathname]
  const whiteLabelsKey2 = {
    '/scriptform': 'ScriptsWhiteLabels',
    '/momentform': 'MomentsWhiteLabels',
    '/eventform': 'EventsWhiteLabels'
  }[window.location.pathname]

  const addWhitelabel = id => [...(formObject[whiteLabelsKey] || []), { whiteLabelId: id }]

  const removeWhitelabel = id =>
    (formObject[whiteLabelsKey] || []).filter(({ whiteLabelId }) => id !== whiteLabelId)

  const toggleWhitelabel = (id, checked) => {
    let fn = checked ? addWhitelabel : removeWhitelabel
    setFormObject(formObject => ({
      ...formObject,
      [whiteLabelsKey]: fn(id)
    }))
  }

  useEffect(() => {
    // console.log('Usuário', user?.whiteLabelId);
    // console.log('Grupo 6', user?.userGroup == 6);
    ;(user?.userGroup === 6 || user?.userGroup === 7) &&
      setFormObject(formObject => {
        const whiteLabelsKeyArray = formObject[whiteLabelsKey2] ? formObject[whiteLabelsKey2] : []
        if (whiteLabelsKeyArray.some(w => w.whiteLabelId === user?.whiteLabelId)) {
          return {
            ...formObject,
            [whiteLabelsKey]: whiteLabelsKeyArray
          }
        }

        return {
          ...formObject,
          [whiteLabelsKey]: [...whiteLabelsKeyArray, { whiteLabelId: user?.whiteLabelId }]
        }
      })
  }, [user])

  return (
    <div
      style={{
        display: user?.userGroup === 6 ? 'none' : 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: '20px'
      }}
    >
      <h6>Selecionar ofertas</h6>
      <p>(Deixe todos desmarcados para aplicar a todos.)</p>
      {whiteLabels.map(item => (
        <label key={item.id}>
          <input
            type="checkbox"
            value={item.id}
            checked={formObject[whiteLabelsKey]?.some(({ whiteLabelId: id }) => id === item.id)}
            onChange={e => toggleWhitelabel(item.id, e.target.checked)}
          />
          {item.title}
        </label>
      ))}
    </div>
  )
}

export default OffersSelector
